var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._g({
    class: _vm.$style.previewFile
  }, _vm.$listeners), [_vm.resource.assetFileExtension === 'pdf' ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPdfBox,
      expression: "showPdfBox"
    }],
    class: _vm.$style.previewFileBox
  }, [_vm.loadingPdf ? _c('div', {
    class: _vm.$style.previewFileBoxLoading
  }, [_c('LoaderIcon'), _vm._v(" " + _vm._s(Math.floor(_vm.loadedRatio * 100)) + "% ")], 1) : _vm._e(), _c('pdf', {
    attrs: {
      "src": _vm.resource.assetUrl
    },
    on: {
      "loaded": _vm.pdfLoaded,
      "error": _vm.pdfError,
      "progress": function progress($event) {
        _vm.loadedRatio = $event || 0;
      }
    }
  })], 1) : _vm._e(), _c('div', {
    class: _vm.$style.previewFileInfo
  }, [_c('div', {
    class: _vm.$style.previewFileName
  }, [_c('p', [_vm._v(_vm._s(_vm.resource.assetFileName))])]), _c('div', {
    class: _vm.$style.previewFileSize
  }, [_c('p', [_vm._v(_vm._s(_vm.resource.assetSize))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }